import { withValidation } from './Validation';
import { createInputId } from '../../utils/utilities';
import Select from '../Inputs/Select';
import SelectOption from '../Inputs/SelectOption';

const QuestionDropdown = props => {
    const { value, label, questionChoices, handleChange, helperText, required, name } = props;

    if (!questionChoices || !Array.isArray(questionChoices)) {
        return null
    }

    const handleChangeDecorator = (opt) => {
        handleChange({
            target: opt
        })
    }

    const selectOptions = questionChoices.map(choice => {
        return {
            value: choice.gka,
            label: choice.text || choice.label
        }
    })

    const defaultSelection = selectOptions.find(opt => opt.value === value)
    const errorStyle = helperText ? '[&_button]:!ring-cherry-red' : ''

    return (
        <div className={errorStyle}>
            <h6 className='text-base m-0 mb-2 font-normal' id={name}>
                {label} {required ? <span className='text-cherry-red'>*</span>: null}
            </h6>

            <Select
                id={createInputId(name)}
                className={errorStyle}
                onSelection={handleChangeDecorator}
                defaultSelection={defaultSelection || { value: null, label: 'Select an option...' }}
                options={selectOptions}
                renderOption={(option, isSelected) => (
                    <SelectOption label={option.label} isSelected={isSelected} />
                )}
            />

            {helperText && <p data-testid='select-box-error' className='text-cherry-red m-0 text-sm mt-2'>{helperText}</p>}
        </div>
    );
}

export default withValidation(QuestionDropdown);